import {announce} from '@aboutyou/a11y';
import {useGrpcRequestMutation} from '@aboutyou/data-fetcher';
import {Session} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/session.types';
import {BasketPageService_ChangeQuantityLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/service.grpc.lazy';
import {useTranslation} from '@aboutyou/i18n';
import {useBasketToken, useFullSession} from '@aboutyou/user';
import {useCallback} from 'react';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../shared-deprecated/useTargetGroupIdentifier';
import {useUpdateBasketSectionsCallback} from './useUpdateBasketSections';

export const useQuantityChangeHandler = (itemKey: string) => {
  const session = useFullSession() as Session;
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const {t} = useTranslation();

  const {token: minimalStateToken} = useBasketToken();

  const reductionsState = useReductionsStateRequestParameter();

  const updatePageBulkSections = useUpdateBasketSectionsCallback();

  const updateQuantityCallback = useGrpcRequestMutation(
    BasketPageService_ChangeQuantityLazy,
    {
      onSuccess: data => {
        updatePageBulkSections(data.sections);
      },
    },
  );

  const changeQuantity = useCallback(
    async (quantity: number) => {
      const result = await updateQuantityCallback.mutateAsync({
        session,
        quantity,
        itemKey,
        basketToken: minimalStateToken,
        targetGroup: targetGroupIdentifier,
        reductionsState,
      });

      announce(t('Quantity updated to {quantity}', {quantity}), 'polite');

      return result;
    },
    [updateQuantityCallback, itemKey, minimalStateToken, t],
  );

  return {
    changeQuantity,
    isPending: updateQuantityCallback.isPending,
  };
};
